"use client"

import * as React from "react"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { SelectSingleEventHandler } from "react-day-picker"
import { Portal } from "@radix-ui/react-popover"

interface Props {
  date: Date;
  setDate: Function;
}

const DatePicker: React.FC<Props> = ({date, setDate}) => {
  const handleDateChange = (value: any) => {
    const fakeEvent = {
      currentTarget: {
        id: 'date',
        value
      },
    }
    setDate(fakeEvent);
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant={"outline"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !date && "text-muted-foreground"
          )}
        >
          <CalendarIcon />
          {date ? format(date, "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent className="w-auto z-[99] pointer-events-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleDateChange as SelectSingleEventHandler}
          initialFocus
        />
      </PopoverContent>
      </Portal>
    </Popover>
  )
}

export default DatePicker
